import { Routes, Route, Link } from "react-router-dom";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Support from "./pages/Support";
import { useState, useEffect } from "react";

const APP_STORE_URL = "https://apps.apple.com/ca/app/omello/id6761731975?mt=12";

const styles = {
  // Base
  root: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, sans-serif',
    margin: 0,
    padding: 0,
    backgroundColor: "#f5f5f7",
    color: "#1d1d1f",
  },

  // NAV
  nav: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100,
    backgroundColor: "rgba(255,255,255,0.85)",
    backdropFilter: "blur(20px)",
    WebkitBackdropFilter: "blur(20px)",
    borderBottom: "1px solid rgba(0,0,0,0.08)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 40px",
    height: "52px",
  },
  navLogo: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1d1d1f",
    letterSpacing: "-0.5px",
  },
  navLogoAccent: {
    color: "#2563eb",
  },
  navLinks: {
    display: "flex",
    gap: "32px",
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
  navLink: {
    fontSize: "14px",
    color: "#1d1d1f",
    textDecoration: "none",
    fontWeight: "400",
    opacity: 0.8,
    cursor: "pointer",
  },
  navCtaMobile: {
    backgroundColor: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "14px 18px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    width: "100%",
    marginTop: "8px",
    textDecoration: "none",
    textAlign: "center",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
  navOuter: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100,
  },
  navDesktop: {
    display: "flex",
    alignItems: "center",
    gap: "32px",
  },
  navMenuBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "44px",
    height: "44px",
    padding: 0,
    border: "none",
    background: "rgba(0,0,0,0.04)",
    color: "#1d1d1f",
    cursor: "pointer",
    borderRadius: "10px",
    flexShrink: 0,
  },
  navDropdown: {
    position: "absolute",
    top: "52px",
    left: 0,
    right: 0,
    backgroundColor: "rgba(255,255,255,0.98)",
    backdropFilter: "blur(20px)",
    WebkitBackdropFilter: "blur(20px)",
    borderBottom: "1px solid rgba(0,0,0,0.08)",
    padding: "8px 16px 20px",
    boxShadow: "0 16px 48px rgba(0,0,0,0.12)",
    zIndex: 2,
  },
  navBackdrop: {
    position: "fixed",
    top: "52px",
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.2)",
    zIndex: 1,
  },
  navDropdownList: {
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
  navDropdownItem: {
    display: "block",
    width: "100%",
    textAlign: "left",
    fontSize: "16px",
    color: "#1d1d1f",
    fontWeight: "500",
    padding: "14px 10px",
    border: "none",
    background: "none",
    cursor: "pointer",
    borderRadius: "10px",
  },
  navCtaDesktop: {
    backgroundColor: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "20px",
    padding: "8px 18px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    flexShrink: 0,
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },

  // HERO
  hero: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "120px 24px 80px",
    background: "linear-gradient(160deg, #eff6ff 0%, #f5f5f7 50%, #eef2ff 100%)",
    position: "relative",
    overflow: "hidden",
  },
  heroBadge: {
    display: "inline-block",
    backgroundColor: "#dbeafe",
    color: "#1d4ed8",
    fontSize: "13px",
    fontWeight: "600",
    borderRadius: "20px",
    padding: "6px 16px",
    marginBottom: "28px",
    letterSpacing: "0.3px",
  },
  heroTitle: {
    fontSize: "clamp(48px, 8vw, 88px)",
    fontWeight: "800",
    letterSpacing: "-3px",
    lineHeight: 1.05,
    marginBottom: "12px",
    color: "#1d1d1f",
  },
  heroTitleAccent: {
    color: "#2563eb",
  },
  heroTagline: {
    fontSize: "clamp(18px, 2.5vw, 26px)",
    fontWeight: "400",
    color: "#6b7280",
    maxWidth: "640px",
    lineHeight: 1.5,
    marginBottom: "44px",
  },
  heroButtonGroup: {
    display: "flex",
    gap: "16px",
    flexWrap: "wrap",
    justifyContent: "center",
    marginBottom: "64px",
  },
  heroPrimaryBtn: {
    backgroundColor: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "16px 36px",
    fontSize: "17px",
    fontWeight: "700",
    cursor: "pointer",
    boxShadow: "0 8px 24px rgba(37,99,235,0.35)",
    transition: "transform 0.15s, box-shadow 0.15s",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroSecondaryBtn: {
    backgroundColor: "transparent",
    color: "#2563eb",
    border: "2px solid #2563eb",
    borderRadius: "14px",
    padding: "14px 34px",
    fontSize: "17px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "transform 0.15s",
  },
  heroStatsRow: {
    display: "flex",
    gap: "48px",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  heroStat: {
    textAlign: "center",
  },
  heroStatNum: {
    fontSize: "32px",
    fontWeight: "800",
    color: "#2563eb",
    letterSpacing: "-1px",
  },
  heroStatLabel: {
    fontSize: "13px",
    color: "#6b7280",
    fontWeight: "500",
    marginTop: "4px",
  },

  // SECTION SHARED
  section: {
    padding: "96px 24px",
  },
  sectionAlt: {
    padding: "96px 24px",
    backgroundColor: "#fff",
  },
  sectionInner: {
    maxWidth: "1100px",
    margin: "0 auto",
  },
  sectionLabel: {
    fontSize: "13px",
    fontWeight: "700",
    letterSpacing: "1.5px",
    color: "#2563eb",
    textTransform: "uppercase",
    marginBottom: "12px",
  },
  sectionTitle: {
    fontSize: "clamp(30px, 4vw, 48px)",
    fontWeight: "800",
    letterSpacing: "-1.5px",
    color: "#1d1d1f",
    lineHeight: 1.1,
    marginBottom: "16px",
  },
  sectionSubtitle: {
    fontSize: "18px",
    color: "#6b7280",
    maxWidth: "600px",
    lineHeight: 1.6,
    marginBottom: "56px",
  },

  // HOW IT WORKS
  stepsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "24px",
  },
  stepCard: {
    backgroundColor: "#f5f5f7",
    borderRadius: "20px",
    padding: "32px 28px",
    position: "relative",
    border: "1px solid rgba(0,0,0,0.05)",
  },
  stepNumber: {
    width: "40px",
    height: "40px",
    backgroundColor: "#2563eb",
    color: "#fff",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    fontWeight: "800",
    marginBottom: "20px",
  },
  stepTitle: {
    fontSize: "17px",
    fontWeight: "700",
    color: "#1d1d1f",
    marginBottom: "10px",
  },
  stepDesc: {
    fontSize: "15px",
    color: "#6b7280",
    lineHeight: 1.6,
  },
  stepEmoji: {
    fontSize: "28px",
    marginBottom: "8px",
    display: "block",
  },

  // FEATURES
  featuresGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "20px",
  },
  featureCard: {
    backgroundColor: "#f5f5f7",
    borderRadius: "20px",
    padding: "32px",
    border: "1px solid rgba(0,0,0,0.05)",
    transition: "transform 0.2s",
  },
  featureIcon: {
    fontSize: "36px",
    marginBottom: "16px",
    display: "block",
  },
  featureTitle: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#1d1d1f",
    marginBottom: "10px",
  },
  featureDesc: {
    fontSize: "15px",
    color: "#6b7280",
    lineHeight: 1.65,
  },
  featureTag: {
    display: "inline-block",
    backgroundColor: "#dbeafe",
    color: "#1d4ed8",
    fontSize: "11px",
    fontWeight: "700",
    borderRadius: "8px",
    padding: "3px 10px",
    marginTop: "14px",
    letterSpacing: "0.5px",
    textTransform: "uppercase",
  },

  // BENEFITS
  benefitsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "20px",
  },
  benefitCard: {
    backgroundColor: "#eff6ff",
    borderRadius: "20px",
    padding: "32px",
    border: "1px solid #bfdbfe",
  },
  benefitIcon: {
    fontSize: "32px",
    marginBottom: "14px",
    display: "block",
  },
  benefitTitle: {
    fontSize: "17px",
    fontWeight: "700",
    color: "#1d4ed8",
    marginBottom: "10px",
  },
  benefitDesc: {
    fontSize: "15px",
    color: "#374151",
    lineHeight: 1.65,
  },

  // ALL IN ONE
  allInOne: {
    background: "linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)",
    borderRadius: "28px",
    padding: "72px 56px",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  allInOneTitle: {
    fontSize: "clamp(28px, 4vw, 44px)",
    fontWeight: "800",
    letterSpacing: "-1.5px",
    marginBottom: "20px",
    lineHeight: 1.1,
  },
  allInOneSubtitle: {
    fontSize: "18px",
    opacity: 0.85,
    maxWidth: "580px",
    lineHeight: 1.6,
    marginBottom: "40px",
  },
  allInOneGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    gap: "16px",
    width: "100%",
    maxWidth: "800px",
    marginBottom: "44px",
  },
  allInOneItem: {
    backgroundColor: "rgba(255,255,255,0.12)",
    borderRadius: "14px",
    padding: "20px 16px",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255,255,255,0.15)",
  },
  allInOneItemEmoji: {
    fontSize: "28px",
    display: "block",
    marginBottom: "8px",
  },
  allInOneItemLabel: {
    fontSize: "13px",
    fontWeight: "600",
    opacity: 0.9,
  },
  allInOneBtn: {
    backgroundColor: "#fff",
    color: "#2563eb",
    border: "none",
    borderRadius: "14px",
    padding: "14px 32px",
    fontSize: "16px",
    fontWeight: "700",
    cursor: "pointer",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },

  // FAQ
  faqList: {
    maxWidth: "720px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  faqItem: {
    backgroundColor: "#fff",
    borderRadius: "16px",
    border: "1px solid rgba(0,0,0,0.08)",
    overflow: "hidden",
  },
  faqQuestion: {
    padding: "22px 28px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
    color: "#1d1d1f",
    gap: "16px",
  },
  faqChevron: {
    fontSize: "18px",
    transition: "transform 0.25s",
    flexShrink: 0,
    color: "#2563eb",
  },
  faqAnswer: {
    padding: "0 28px 22px",
    fontSize: "15px",
    color: "#6b7280",
    lineHeight: 1.7,
  },

  // FOOTER
  footer: {
    backgroundColor: "#1d1d1f",
    color: "#fff",
    padding: "64px 24px 40px",
  },
  footerInner: {
    maxWidth: "1100px",
    margin: "0 auto",
  },
  footerTop: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "48px",
    marginBottom: "48px",
    paddingBottom: "48px",
    borderBottom: "1px solid rgba(255,255,255,0.1)",
  },
  footerBrand: {},
  footerBrandName: {
    fontSize: "24px",
    fontWeight: "800",
    letterSpacing: "-0.5px",
    marginBottom: "10px",
  },
  footerBrandAccent: {
    color: "#60a5fa",
  },
  footerBrandTagline: {
    fontSize: "14px",
    color: "rgba(255,255,255,0.5)",
    lineHeight: 1.6,
    maxWidth: "260px",
  },
  footerCol: {},
  footerColTitle: {
    fontSize: "14px",
    fontWeight: "700",
    letterSpacing: "0.5px",
    marginBottom: "16px",
    color: "rgba(255,255,255,0.9)",
    textTransform: "uppercase",
  },
  footerPlaceholder: {
    fontSize: "14px",
    color: "rgba(255,255,255,0.4)",
    lineHeight: 1.8,
  },
  footerBottom: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "16px",
  },
  footerCopy: {
    fontSize: "13px",
    color: "rgba(255,255,255,0.35)",
  },
  footerLinks: {
    display: "flex",
    gap: "24px",
  },
  footerLink: {
    fontSize: "13px",
    color: "rgba(255,255,255,0.45)",
    textDecoration: "none",
    cursor: "pointer",
  },
};

// ─── Data ────────────────────────────────────────────────────────────────────

const steps = [
  {
    emoji: "🎙️",
    title: "Open Omello & Start Listening",
    desc: "Launch the app, choose your context (Lecture, Meeting, or General), and hit record. Omello listens in real time so you don't have to write a single word.",
  },
  {
    emoji: "🧠",
    title: "Get Quizzed While You Learn",
    desc: "At your chosen interval, Omello pauses and quizzes you on what was just covered—keeping your mind sharp and your attention locked in.",
  },
  {
    emoji: "📝",
    title: "Review Your Complete Note",
    desc: "When the session ends, you have a full transcript, every quiz from the session, and optional audio—all saved together in one place.",
  },
  {
    emoji: "🚀",
    title: "Study Smarter, Not Longer",
    desc: "Use AI Q&A, generate flashcards, build a cram sheet, or jump into Exam Mode—everything you need to truly master the material.",
  },
];

const features = [
  {
    emoji: "🎙️",
    title: "Live Lecture Transcription",
    desc: "Omello listens and transcribes your lecture in real time, capturing everything so nothing slips through the cracks while you focus on understanding.",
    tag: "Core",
  },
  {
    emoji: "❓",
    title: "Auto-Generated In-Lecture Quizzes",
    desc: "Quizzes are automatically generated at your chosen time interval with adjustable difficulty, keeping you actively engaged throughout every session.",
    tag: "Active Learning",
  },
  {
    emoji: "🤖",
    title: "6 AI Models to Choose From",
    desc: "Pick from 4 local models for complete privacy or 2 cloud models for top-tier note quality—no compromise between power and privacy.",
    tag: "Privacy & Power",
  },
  {
    emoji: "🔒",
    title: "100% Private Local Processing",
    desc: "With local AI models, your transcripts and notes never leave your Mac. Your lectures stay yours—always.",
    tag: "Privacy",
  },
  {
    emoji: "💬",
    title: "AI-Powered Q&A on Any Note",
    desc: "Ask any question about a lecture and the AI answers using the actual transcript as context—accurate, specific, and instant.",
    tag: "AI",
  },
  {
    emoji: "🃏",
    title: "Flashcards & Exam Mode",
    desc: "Review quiz questions as flashcards for any note, or select multiple notes and enter Exam Mode for a randomized cross-topic practice session.",
    tag: "Review",
  },
  {
    emoji: "📄",
    title: "AI Cram Sheets",
    desc: "Select any combination of notes and let AI distill them into a concise, no-fluff cram sheet covering only what matters most before an exam.",
    tag: "Exam Prep",
  },
  {
    emoji: "🎛️",
    title: "Fully Customizable Sessions",
    desc: "Set quiz frequency, difficulty, lecture context, recording preferences, and AI model—tailor every session exactly to your needs.",
    tag: "Personalized",
  },
  {
    emoji: "📓",
    title: "Personal Notes Alongside AI Notes",
    desc: "Write your own thoughts, highlights, or corrections directly in the note—they're saved right alongside the AI-generated content.",
    tag: "Flexibility",
  },
];

const benefits = [
  {
    emoji: "🎯",
    title: "Stay Focused in Class",
    desc: "Stop splitting your attention between listening and writing. Omello handles note-taking so you can be fully present and absorb more of what's being taught.",
  },
  {
    emoji: "⚡",
    title: "Never Miss Key Concepts",
    desc: "Regular in-lecture quizzes make sure you're actually understanding what's covered—not just passively listening and drifting off.",
  },
  {
    emoji: "📚",
    title: "One Place for Everything",
    desc: "Transcript, recording, quizzes, flashcards, cram sheets, AI Q&A, and personal notes—all organized and accessible from a single app.",
  },
  {
    emoji: "🛡️",
    title: "You Control Your Privacy",
    desc: "Sensitive lecture content? Use a local model and keep everything on-device. Need premium summaries? Switch to a cloud model anytime.",
  },
];

const allInOneItems = [
  { emoji: "🎙️", label: "Live Transcription" },
  { emoji: "❓", label: "Auto Quizzes" },
  { emoji: "🃏", label: "Flashcards" },
  { emoji: "💬", label: "AI Q&A" },
  { emoji: "📄", label: "Cram Sheets" },
  { emoji: "🎓", label: "Exam Mode" },
  { emoji: "📓", label: "Personal Notes" },
  { emoji: "🔒", label: "Local AI Privacy" },
];

const faqs = [
  {
    q: "How does Omello keep me focused during a lecture?",
    a: "Omello automatically generates quizzes at regular intervals you define—so instead of passively listening, you're regularly tested on what was just covered. This keeps your brain actively processing the material instead of drifting off.",
  },
  {
    q: "Are my notes and recordings private?",
    a: "Absolutely. Omello offers four local AI models that run entirely on your Mac, meaning your transcripts, recordings, and notes never leave your device. If you prefer cloud processing for higher-quality results, that option is available too—the choice is always yours.",
  },
  {
    q: "Can I use Omello for meetings, not just lectures?",
    a: "Yes! Omello supports multiple contexts—Lecture, Meeting, and General. Each context tailors the quiz generation and note style to be appropriate for what you're attending, making it just as useful in a work meeting as in a university lecture hall.",
  },
  {
    q: "What happens after the lecture ends?",
    a: "Once your session is over, Omello saves a complete package: the full transcript, all quizzes asked during the session, and the audio recording if you enabled it. From there you can review flashcards, ask the AI questions, generate more quizzes, write personal notes, or build a cram sheet.",
  },
  {
    q: "Can I study across multiple lectures at once?",
    a: "Yes. With Exam Mode, you can select any number of notes and get a randomized quiz pulling questions from all of them. The AI Cram Sheet feature also lets you merge insights from multiple lectures into one concise study guide.",
  },
  {
    q: "What Mac hardware do I need to run the local AI models?",
    a: "Omello is designed for macOS and takes advantage of Apple Silicon efficiency. The four local models range from lightweight to powerful, so you can choose based on your Mac's capabilities. Cloud models are always available as a fallback if needed.",
  },
];

// ─── Sub-components ───────────────────────────────────────────────────────────

const NAV_LINKS = [
  { label: "Features", id: "features" },
  { label: "How It Works", id: "how-it-works" },
  { label: "Benefits", id: "benefits" },
  { label: "FAQ", id: "faq" },
];

function Nav() {
  const [isMobile, setIsMobile] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const sync = () => {
      setIsMobile(mq.matches);
      if (!mq.matches) setMenuOpen(false);
    };
    sync();
    mq.addEventListener("change", sync);
    return () => mq.removeEventListener("change", sync);
  }, []);

  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [menuOpen]);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const handleNavItem = (id) => {
    scrollTo(id);
    setMenuOpen(false);
  };

  return (
    <div style={styles.navOuter}>
      <nav
        style={{
          ...styles.nav,
          padding: isMobile ? "0 16px" : "0 40px",
          position: "relative",
          zIndex: 3,
        }}
      >
        <div style={styles.navLogo}>
          Om<span style={styles.navLogoAccent}>ello</span>
        </div>
        {!isMobile && (
          <div style={styles.navDesktop}>
            <ul style={styles.navLinks}>
              {NAV_LINKS.map((item) => (
                <li key={item.label}>
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => scrollTo(item.id)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        scrollTo(item.id);
                      }
                    }}
                    style={styles.navLink}
                  >
                    {item.label}
                  </span>
                </li>
              ))}
            </ul>
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noreferrer"
              style={styles.navCtaDesktop}
            >
              Download Omello
            </a>
          </div>
        )}
        {isMobile && (
          <button
            type="button"
            aria-expanded={menuOpen}
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            style={styles.navMenuBtn}
            onClick={() => setMenuOpen((o) => !o)}
          >
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              aria-hidden
            >
              {menuOpen ? (
                <path d="M18 6L6 18M6 6l12 12" />
              ) : (
                <>
                  <path d="M4 7h16M4 12h16M4 17h16" />
                </>
              )}
            </svg>
          </button>
        )}
      </nav>
      {isMobile && menuOpen && (
        <>
          <div
            style={styles.navBackdrop}
            onClick={() => setMenuOpen(false)}
            aria-hidden
          />
          <div style={styles.navDropdown}>
            <ul style={styles.navDropdownList}>
              {NAV_LINKS.map((item) => (
                <li key={item.label}>
                  <button
                    type="button"
                    style={styles.navDropdownItem}
                    onClick={() => handleNavItem(item.id)}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noreferrer"
              style={styles.navCtaMobile}
              onClick={() => setMenuOpen(false)}
            >
              Download Omello
            </a>
          </div>
        </>
      )}
    </div>
  );
}

function Hero() {
  return (
    <section style={styles.hero}>
      <span style={styles.heroBadge}>🍎 macOS App · Available Now</span>
      <h1 style={styles.heroTitle}>
        Om<span style={styles.heroTitleAccent}>ello</span>
      </h1>
      <p style={styles.heroTagline}>
        Stop taking notes. Start understanding lectures. Omello listens,
        transcribes, quizzes you live, and organizes everything—so you can
        actually focus on learning.
      </p>
      <div style={styles.heroButtonGroup}>
        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noreferrer"
          style={styles.heroPrimaryBtn}
        >
          Download on the Mac App Store
        </a>
        <button
          style={styles.heroSecondaryBtn}
          onClick={() =>
            document.getElementById("how-it-works").scrollIntoView({ behavior: "smooth" })
          }
        >
          See How It Works ↓
        </button>
      </div>
      <div style={styles.heroStatsRow}>
        {[
          { num: "6", label: "AI Models" },
          { num: "4", label: "Local & Private" },
          { num: "∞", label: "Quiz Questions" },
          { num: "1", label: "App for Everything" },
        ].map((s) => (
          <div key={s.label} style={styles.heroStat}>
            <div style={styles.heroStatNum}>{s.num}</div>
            <div style={styles.heroStatLabel}>{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

function HowItWorks() {
  return (
    <section id="how-it-works" style={styles.sectionAlt}>
      <div style={styles.sectionInner}>
        <p style={styles.sectionLabel}>How It Works</p>
        <h2 style={styles.sectionTitle}>Simple to start. Powerful to use.</h2>
        <p style={styles.sectionSubtitle}>
          Omello fits naturally into your existing routine—no new habits
          required. Just open the app and let it do the heavy lifting.
        </p>
        <div style={styles.stepsGrid}>
          {steps.map((step, i) => (
            <div key={i} style={styles.stepCard}>
              <div style={styles.stepNumber}>{i + 1}</div>
              <span style={styles.stepEmoji}>{step.emoji}</span>
              <h3 style={styles.stepTitle}>{step.title}</h3>
              <p style={styles.stepDesc}>{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Features() {
  return (
    <section id="features" style={styles.section}>
      <div style={styles.sectionInner}>
        <p style={styles.sectionLabel}>Features</p>
        <h2 style={styles.sectionTitle}>
          Everything a student needs, nothing they don't.
        </h2>
        <p style={styles.sectionSubtitle}>
          Every feature in Omello was built around one goal: help you learn
          better with less effort.
        </p>
        <div style={styles.featuresGrid}>
          {features.map((f, i) => (
            <div key={i} style={styles.featureCard}>
              <span style={styles.featureIcon}>{f.emoji}</span>
              <h3 style={styles.featureTitle}>{f.title}</h3>
              <p style={styles.featureDesc}>{f.desc}</p>
              <span style={styles.featureTag}>{f.tag}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Benefits() {
  return (
    <section id="benefits" style={styles.sectionAlt}>
      <div style={styles.sectionInner}>
        <p style={styles.sectionLabel}>Benefits</p>
        <h2 style={styles.sectionTitle}>
          Learn more. Study less. Stress less.
        </h2>
        <p style={styles.sectionSubtitle}>
          Omello doesn't just record your lectures—it transforms the way you
          engage with and retain them.
        </p>
        <div style={styles.benefitsGrid}>
          {benefits.map((b, i) => (
            <div key={i} style={styles.benefitCard}>
              <span style={styles.benefitIcon}>{b.emoji}</span>
              <h3 style={styles.benefitTitle}>{b.title}</h3>
              <p style={styles.benefitDesc}>{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function AllInOne() {
  return (
    <section style={{ padding: "80px 24px" }}>
      <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
        <div style={styles.allInOne}>
          <p
            style={{
              fontSize: "13px",
              fontWeight: "700",
              letterSpacing: "1.5px",
              textTransform: "uppercase",
              opacity: 0.7,
              marginBottom: "12px",
            }}
          >
            All-in-One Experience
          </p>
          <h2 style={styles.allInOneTitle}>
            One app. Every study tool you'll ever need.
          </h2>
          <p style={styles.allInOneSubtitle}>
            Why juggle a voice recorder, a notes app, a flashcard tool, and an
            AI chatbot? Omello replaces them all—tightly integrated and
            designed to work together from the moment you hit record.
          </p>
          <div style={styles.allInOneGrid}>
            {allInOneItems.map((item, i) => (
              <div key={i} style={styles.allInOneItem}>
                <span style={styles.allInOneItemEmoji}>{item.emoji}</span>
                <span style={styles.allInOneItemLabel}>{item.label}</span>
              </div>
            ))}
          </div>
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noreferrer"
            style={styles.allInOneBtn}
          >
            Download Omello
          </a>
        </div>
      </div>
    </section>
  );
}

function FAQ() {
  const [open, setOpen] = useState(null);
  return (
    <section id="faq" style={styles.sectionAlt}>
      <div style={styles.sectionInner}>
        <p style={{ ...styles.sectionLabel, textAlign: "center" }}>FAQ</p>
        <h2 style={{ ...styles.sectionTitle, textAlign: "center" }}>
          Questions? Answered.
        </h2>
        <p
          style={{
            ...styles.sectionSubtitle,
            textAlign: "center",
            margin: "0 auto 48px",
          }}
        >
          Everything you need to know before you download.
        </p>
        <div style={styles.faqList}>
          {faqs.map((faq, i) => (
            <div key={i} style={styles.faqItem}>
              <div
                style={styles.faqQuestion}
                onClick={() => setOpen(open === i ? null : i)}
              >
                <span>{faq.q}</span>
                <span
                  style={{
                    ...styles.faqChevron,
                    transform: open === i ? "rotate(180deg)" : "rotate(0deg)",
                  }}
                >
                  ▾
                </span>
              </div>
              {open === i && <p style={styles.faqAnswer}>{faq.a}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer style={styles.footer}>
      <div style={styles.footerInner}>
        <div style={styles.footerTop}>
          {/* Brand */}
          <div style={styles.footerBrand}>
            <div style={styles.footerBrandName}>
              Om<span style={styles.footerBrandAccent}>ello</span>
            </div>
            <p style={styles.footerBrandTagline}>
              The smarter way to attend, understand, and review lectures—all in
              one app for macOS.
            </p>
          </div>

          {/* Privacy Policy */}
          <div style={styles.footerCol}>
            <h3 style={styles.footerColTitle}>Privacy Policy</h3>
            <Link to="/privacy-policy" style={{ ...styles.footerLink, marginTop: "12px", display: "inline-block" }}>
              Read Privacy Policy →
            </Link>
          </div>

          {/* Support */}
          <div style={styles.footerCol}>
            <h3 style={styles.footerColTitle}>Support</h3>
            <Link to="/support" style={{ ...styles.footerLink, marginTop: "12px", display: "inline-block" }}>
              Get Support →
            </Link>
          </div>
        </div>

        <div style={styles.footerBottom}>
          <span style={styles.footerCopy}>
            © {new Date().getFullYear()} Omello. All rights reserved. macOS is
            a trademark of Apple Inc.
          </span>
          <div style={styles.footerLinks}>
            <Link to="/privacy-policy" style={styles.footerLink}>
              Privacy Policy
            </Link>
            <Link to="/support" style={styles.footerLink}>
              Support
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

// ─── App ─────────────────────────────────────────────────────────────────────

export default function App() {
  return (
    <div style={styles.root}>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Nav />
              <Hero />
              <HowItWorks />
              <Features />
              <Benefits />
              <AllInOne />
              <FAQ />
              <Footer />
            </>
          }
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/support" element={<Support />} />
      </Routes>
    </div>
  );
}